"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabled = exports.OfferingType = void 0;
var active_features_const_1 = require("./active-features.const");
var OfferingType;
(function (OfferingType) {
    OfferingType["INDIVIDUAL"] = "INDIVIDUAL";
    OfferingType["GROUP"] = "GROUP";
    OfferingType["TOUR"] = "TOUR";
    OfferingType["COURSE"] = "COURSE";
    OfferingType["DUMMY"] = "DUMMY";
})(OfferingType = exports.OfferingType || (exports.OfferingType = {}));
var offeringTypeToFeatureMapping = (_a = {},
    _a[OfferingType.INDIVIDUAL] = active_features_const_1.Features.INDIVIDUAL,
    _a[OfferingType.COURSE] = active_features_const_1.Features.COURSE,
    _a[OfferingType.TOUR] = active_features_const_1.Features.COURSE,
    _a[OfferingType.GROUP] = active_features_const_1.Features.GROUPS,
    _a);
function isFeatureEnabled(activeFeatures, type) {
    var featureName = offeringTypeToFeatureMapping[type];
    if (activeFeatures.hasOwnProperty(featureName)) {
        return activeFeatures[featureName];
    }
    return true;
}
exports.isFeatureEnabled = isFeatureEnabled;
//# sourceMappingURL=feature-enabler.js.map